<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div :class="context.classes.element" data-type="textarea">
    <FormulateSlot name="prefix" :context="context">
      <component
        :is="context.slotComponents.prefix"
        v-if="context.slotComponents.prefix"
        :context="context"
      />
    </FormulateSlot>
    <textarea
      v-model="context.model"
      v-bind="attributes"
      :class="{
        'textarea-input--clearable': canClear,
        'textarea-input--has-rows': hasRows,
      }"
      v-on="$listeners"
      @blur="context.blurHandler"
    />
    <button
      v-if="canClear && clearable"
      type="button"
      class="textarea-input__clear"
      aria-label="Hapus isi input"
      @mousedown.prevent
      @click="clear"
    >
      <i class="icon-fill_close-circle" />
    </button>
    <span v-if="maxLength !== null" class="textarea-input__counter">
      {{ valueLength }}/{{ maxLength }}
    </span>
    <FormulateSlot name="suffix" :context="context">
      <component
        :is="context.slotComponents.suffix"
        v-if="context.slotComponents.suffix"
        :context="context"
      />
    </FormulateSlot>
  </div>
</template>

<script>
export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    attributes() {
      return this.context.attributes || {}
    },
    maxLength() {
      const maxLength = Number(this.attributes.maxlength)
      return Number.isInteger(maxLength) && maxLength >= 0 ? maxLength : null
    },
    hasRows() {
      return Number(this.attributes.rows) > 0
    },
    valueLength() {
      return this.context.model == null ? 0 : String(this.context.model).length
    },
    canClear() {
      return (
        this.context.model !== '' &&
        this.context.model !== null &&
        this.context.model !== undefined &&
        !this.attributes.disabled &&
        !this.attributes.readonly
      )
    },
  },
  methods: {
    clear() {
      // Vue Formulate exposes the field model through its input context.
      // eslint-disable-next-line vue/no-mutating-props
      this.context.model = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.formulate-input-element--textarea {
  position: relative;
}

textarea {
  padding-bottom: 18px;
}

.textarea-input--has-rows {
  height: auto !important;
  min-height: 37px;
}

.textarea-input--clearable {
  padding-right: 26px !important;
}

.textarea-input__clear {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  color: #67718b;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.textarea-input__clear:focus-visible {
  outline: 2px solid #d6e0ff;
}

.textarea-input__counter {
  position: absolute;
  right: 18px;
  bottom: 4px;
  color: #67718b;
  font-size: 10px;
  line-height: 1;
  pointer-events: none;
}
</style>
